export default __webpack_public_path__ + "static/media/6.WorldTradeCentre.add6b25d.jpg";